var site = 'https://paf.fetenationale.gouv.qc.ca/api';
var imageSource = 'https://paf.fetenationale.gouv.qc.ca';
/*
if (window.location.href.indexOf("pixelcircus") > -1 || window.location.href.indexOf("localhost") > -1 || window.location.href.indexOf("d3v") > -1 ) {
    if(window.location.href.indexOf("loadprod") > -1) {}else{
        console.warn(
            '%c%s',
            'font-size:24px;font-weight:700;',
            'Stage loadé!'
        );
    site = 'https://paf.fetenationale.activ.is/api';
        imageSource = 'https://paf.fetenationale.activ.is';
    }
}*/

var variables = {
    site: site,
    imageSource:imageSource
}
export default variables;